<script lang="ts">
  import type { Permission } from '@clinic/contracts';
  import type { Snippet } from 'svelte';
  import { useOrg } from '../shared/auth/org.svelte';
  import { fa } from '../shared/i18n/fa';
  import { Alert } from '../shared/ui';

  /** One permission, or any of several (e.g. Settings: the admin's tabs or a doctor's own tab). */
  let { permission, children }: { permission?: Permission | readonly Permission[]; children: Snippet } = $props();
  const org = useOrg();
  const allowed = $derived(
    permission === undefined || (typeof permission === 'string' ? [permission] : permission).some((p) => org.can(p)),
  );
</script>

{#if allowed}
  {@render children()}
{:else}
  <Alert tone="error">{fa.app.forbidden}</Alert>
{/if}
